import { render, staticRenderFns } from "./PraticaActions.vue?vue&type=template&id=175b8d40&scoped=true&"
import script from "./PraticaActions.vue?vue&type=script&lang=js&"
export * from "./PraticaActions.vue?vue&type=script&lang=js&"
import style0 from "./PraticaActions.vue?vue&type=style&index=0&id=175b8d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175b8d40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('175b8d40')) {
      api.createRecord('175b8d40', component.options)
    } else {
      api.reload('175b8d40', component.options)
    }
    module.hot.accept("./PraticaActions.vue?vue&type=template&id=175b8d40&scoped=true&", function () {
      api.rerender('175b8d40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaActions.vue"
export default component.exports